module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "pb-0 grey lighten-5",
    attrs: {
      "id": "main-navigation",
      "persistent": "",
      "clipped": "",
      "floating": "",
      "height": "100%",
      "light": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('v-list', {
    staticClass: "grey lighten-5",
    attrs: {
      "dense": ""
    }
  }, [(_vm.showProfile) ? _c('v-container', {
    attrs: {
      "pa-0": "",
      "ma-0": "",
      "hidden-md-and-up": "",
      "text-xs-center": ""
    }
  }, [_c('v-list', {
    staticClass: "grey lighten-5",
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": _vm.profile.picture
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "grey--text text--darken-4",
    domProps: {
      "innerHTML": _vm._s(_vm.profile.email)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.profile.sub)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-xs-right": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "flat": "",
      "text-xs-right": ""
    },
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign out")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-1",
    attrs: {
      "dark": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n                        " + _vm._s(item.heading) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [(item.editable) ? _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      }
    }, [_vm._v("edit")]) : _vm._e()], 1)], 1) : (item.divider) ? _c('v-divider', {
      key: i,
      staticClass: "my-1",
      attrs: {
        "dark": ""
      }
    }) : _c('v-list-tile', {
      key: i,
      on: {
        "click": function($event) {
          _vm.nav(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                        " + _vm._s(item.text) + "\n                    ")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4733b8fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNavigation.vue
// module id = 338
// module chunks = 2